<template>
  <div class="body">
    <div class="detay">
      <div class="sayfahead tek">
        <h1>Satış ve Pazarlama Pörtföy Takip</h1>
        <el-button type="info" size="small" class="YeniBtn" @click="YeniUrunModal=true">
          Yeni Görüşme
        </el-button>
      </div>
      <div class="icerik">
        Yapım Aşamasında
      </div>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      YeniUrunModal: false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Pazarlama/Index.vue